import React from "react";
import { Link } from "react-router-dom";
const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 w-full bg-bg-secondary border-t border-main-border py-2">
      <div className="container mx-auto text-center text-xs text-text-secondary flex flex-col md:flex-row items-center justify-center gap-2">
        <span>© {new Date().getFullYear()} Sinecure.ai — All Rights Reserved.</span>
        <Link
          to="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-2 text-primary hover:text-primary-dark transition-colors"
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
};

export default Footer;